import { gql } from "@apollo/client"

export const ALL_GAMES = gql`
  query allGames {
    allGames(orderBy: sortOrder_ASC) {
      name
      description
      urlImage
      urlUpdate
      image
      sortOrder
      id
      urlActiveSeason
      totalTournaments
      isActive
    }
  }
`

export const ALL_GAMES_WITH_SEASONS = gql`
  query allGames {
    allGames(orderBy: sortOrder_ASC) {
      name
      description
      urlImage
      urlUpdate
      image
      id
      urlActiveSeason
      totalTournaments
      isActive
      Seasons(filter: { isArchived: 0 }, orderBy: startDate_DESC) {
        id
        name
        description
        startDate
        endDate
        gameId
        isActive
        isArchived
      }
    }
  }
`

export const ALL_GAMES_WITH_ALL_SEASONS = gql`
  query allGames {
    allGames(orderBy: sortOrder_ASC) {
      name
      description
      urlImage
      urlUpdate
      image
      id
      urlActiveSeason
      totalTournaments
      isActive
      Seasons(orderBy: startDate_DESC) {
        id
        name
        description
        startDate
        endDate
        gameId
        isActive
        isArchived
      }
    }
  }
`

export const GET_GAMES = gql`
  query GetGames($filter: GameFilter, $orderBy: GameOrderBy, $page: Int, $paginate: Int) {
    games(filter: $filter, orderBy: $orderBy, page: $page, paginate: $paginate) {
      id
      name
      description
      image
      website
      rules
      status
      isActive
      urlImage
      urlIcon
      urlUpdate
      totalTournaments
      urlActiveSeason
    }
  }
`

export const GET_GAME_BY_ID = gql`
  query GetGameById($id: Int!) {
    game(id: $id) {
      id
      name
      description
      image
      website
      rules
      status
      isActive
      urlImage
      urlIcon
      urlUpdate
      totalTournaments
      urlActiveSeason
      Formats(filter: { status: 1 }, orderBy: sortOrder_ASC) {
        id
        name
        description
        image
        status
        deckbuilder
        maxCopies
        minDeck
        maxDeck
        sideboard
        extraCards
        totalTournaments
      }
    }
  }
`

export const GET_ACTIVE_GAMES = gql`
  query GetActiveGames {
    games(filter: { isActive: 1, status: 1 }, orderBy: name_ASC) {
      id
      name
      description
      image
      website
      urlImage
      urlIcon
      totalTournaments
      urlActiveSeason
    }
  }
`
